import { BarChart3 } from "lucide-react";

/** O que um gráfico mostra quando o recorte não tem nada. Ver o
 *  cabeçalho de `Panel.tsx` pela origem. */
export function EmptyState({ label = "Sem dados para os filtros selecionados" }: { label?: string }) {
  return <div className="dashboard-empty"><BarChart3 size={22} aria-hidden="true"/><span>{label}</span></div>;
}
